
export const AI_SEARCH_PROMPT_CHIPS = [
  'My dog ate chocolate',         // EMERGENCY 
  'Are grapes safe for dogs?',    // INFO
  'How do I introduce two cats?', // INFO
  'Lost my dog nearby',           // lost_pet
  'Found a stray cat',            // found_pet
  'Looking for a groomer',        // find_service
  'Weather hazards near me',      // weather_hazard
];
